// src/components/LotsEditor.jsx
import React from "react";
import UploadField from "./UploadField";
import { steps } from "../utils/tracking";

export default function LotsEditor({ lots, setLots }) {
  const add = () =>
    setLots((arr) => [
      ...arr,
      {
        step: "warehouse",
        qty: 1,
        note: "",
        date: new Date().toISOString(),
        images: [],
        // 👇 champs spécifiques conteneur (vides par défaut)
        containerNo: "",
        shippingUrl: "",
      },
    ]);

  const update = (i, patch) =>
    setLots((arr) => arr.map((l, idx) => (idx === i ? { ...l, ...patch } : l)));

  const remove = (i) => setLots((arr) => arr.filter((_, idx) => idx !== i));

  return (
    <div className="border rounded p-3">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="m-0">Étapes de livraison (lots)</h6>
        <button className="btn btn-sm btn-outline-primary" type="button" onClick={add}>
          + Ajouter
        </button>
      </div>

      {lots.map((l, i) => (
        <div className="row g-2 align-items-end mb-3" key={i}>
          <div className="col-6 col-md-3">
            <label className="form-label">Étape</label>
            <select
              className="form-select"
              value={l.step}
              onChange={(e) => update(i, { step: e.target.value })}
            >
              {steps.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.label}
                </option>
              ))}
            </select>
          </div>

          <div className="col-6 col-md-2">
            <label className="form-label">Qté</label>
            <input
              type="number"
              className="form-control"
              value={l.qty}
              onChange={(e) => update(i, { qty: Number(e.target.value || 0) })}
            />
          </div>

          <div className="col-12 col-md-5">
            <label className="form-label">Note</label>
            <input
              className="form-control"
              value={l.note}
              onChange={(e) => update(i, { note: e.target.value })}
              placeholder="Ex: 2 cartons déposés à l'entrepôt…"
            />
          </div>

          <div className="col-12 col-md-2">
            <label className="form-label">Date</label>
            <input
              type="datetime-local"
              className="form-control"
              value={l.date?.slice(0, 16)}
              onChange={(e) => update(i, { date: new Date(e.target.value).toISOString() })}
            />
          </div>

          {/* 👇 Champs visibles SEULEMENT pour l'étape 'container' */}
          {l.step === "container" && (
            <>
              <div className="col-md-4">
                <label className="form-label">N° de conteneur</label>
                <input
                  className="form-control"
                  placeholder="Ex: MSCU1234567"
                  value={l.containerNo || ""}
                  onChange={(e) => update(i, { containerNo: e.target.value })}
                />
              </div>
              <div className="col-md-8">
                <label className="form-label">Lien du site de shipping</label>
                <input
                  type="url"
                  className="form-control"
                  placeholder="https://..."
                  value={l.shippingUrl || ""}
                  onChange={(e) => update(i, { shippingUrl: e.target.value })}
                />
              </div>
            </>
          )}

          <div className="col-12">
            <label className="form-label">Preuves (images)</label>
            <UploadField
              pathPrefix={`colis/lots`}
              onUploaded={(url) => update(i, { images: [...(l.images || []), url] })}
            />
            {(l.images || []).length > 0 && (
              <div className="d-flex flex-wrap gap-2 mt-2">
                {l.images.map((u, idx) => (
                  <div key={idx} className="position-relative">
                    <img
                      src={u}
                      alt="lot"
                      style={{ width: 88, height: 88, objectFit: "cover" }}
                      className="rounded border"
                    />
                    <button
                      type="button"
                      className="btn btn-sm btn-light position-absolute top-0 end-0"
                      onClick={() => update(i, { images: l.images.filter((_, k) => k !== idx) })}
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="col-12 text-end">
            <button
              className="btn btn-sm btn-outline-danger"
              type="button"
              onClick={() => remove(i)}
            >
              Supprimer
            </button>
          </div>

          <div className="col-12">
            <hr className="my-2" />
          </div>
        </div>
      ))}

      {lots.length === 0 && <div className="text-muted">Aucun lot saisi.</div>}
    </div>
  );
}
